import { Component, Input } from '@angular/core';
import { OrderEntry, PromotionLocation } from '@spartacus/cart/base/root';
import { Consignment, Order } from '@spartacus/order/root';

@Component({
  selector: 'cx-order-consigned-entries',
  templateUrl: './order-consigned-entries.component.html',
  standalone: false
})
export class OrderConsignedEntriesComponent {
  @Input() consignments: Consignment[];
  @Input() order: Order;
  promotionLocation: PromotionLocation = PromotionLocation.Order;

  getConsignmentProducts(consignment: Consignment): OrderEntry[] {
    const products: OrderEntry[] = [];
    consignment.entries.forEach((element) => {
      products.push(element.orderEntry);
    });

    return products;
  }
}
